<template>
  <div class="vac-card-window" :style="[{ height }, cssVars]">
    <div class="vac-chat-container">
      <!-- Room list -->
      <rooms-list
          v-if="!singleRoomCasted"
          :current-user-id="currentUserId"
          :rooms="orderedRooms"
          :loading-rooms="loadingRoomsCasted"
          :rooms-loaded="roomsLoadedCasted"
          :room="room"
          :room-actions="roomActionsCasted"
          :custom-search-room-enabled="customSearchRoomEnabled"
          :text-messages="t"
          :show-search="showSearchCasted"
          :show-add-room="showAddRoomCasted"
          :show-rooms-list="showRoomsList && roomsListOpenedCasted"
          :text-formatting="textFormattingCasted"
          :link-options="linkOptionsCasted"
          :is-mobile="isMobile"
          :scroll-distance="scrollDistance"
          @fetch-room="fetchRoom"
          @close-room="closeRoom"
          @fetch-more-rooms="fetchMoreRooms"
          @loading-more-rooms="loadingMoreRooms = $event"
          @add-room="addRoom"
          @search-room="searchRoom"
          @room-action-handler="roomActionHandler"
          @room-menu-open="handleRoomMenuOpen"
      >
        <template #rooms-header>
          <div class="userInfo">
            <div class="left" style="display: flex">
              <div class="wa-user-avatar" :style="avatarBgStyle"></div>
              <img
                  class="wa-user-avatar-preload"
                  :src="avatarSrc"
                  @error="handleAvatarError"
                  @load="handleAvatarLoad"
                  alt=""
              />
              <div style="margin-left: 10px;">
                <div class="username">{{ waUserDisplayName }}</div>
                <div class="userid">{{ waUserDisplayId }}</div>
              </div>
            </div>
            <div class="right">
              <img style="cursor: pointer" @click="handleClickCreate" src="../img/wa1.png"/>
              <img
                :class="{ 'wa-refresh-rotating': syncingUserContact }"
                style="cursor: pointer"
                @click="handleRefresh"
                src="../img/wa2.png"
              />
              <img style="cursor: pointer" @click="handleLogout" src="../img/wa3.png"/>
            </div>
          </div>
        </template>
        <template v-for="el in slots" #[el.slot]="data">
          <slot :name="el.slot" v-bind="data"/>
        </template>
      </rooms-list>

      <room
          ref="roomRef"
          :current-user-id="currentUserId"
          :rooms="roomsWithSelected"
          :room-id="room.roomId || ''"
          :load-first-room="loadFirstRoomCasted"
          :messages="messagesCasted"
          :room-message="roomMessage"
          :messages-loaded="messagesLoadedCasted"
          :menu-actions="menuActionsCasted"
          :message-actions="messageActionsCasted"
          :message-selection-actions="messageSelectionActionsCasted"
          :auto-scroll="autoScrollCasted"
          :show-send-icon="showSendIconCasted"
          :show-files="showFilesCasted"
          :show-audio="showAudioCasted"
          :audio-bit-rate="audioBitRate"
          :audio-sample-rate="audioSampleRate"
          :show-emojis="showEmojisCasted"
          :show-reaction-emojis="showReactionEmojisCasted"
          :show-new-messages-divider="showNewMessagesDividerCasted"
          :show-footer="showFooterCasted"
          :text-messages="t"
          :single-room="singleRoomCasted"
          :show-rooms-list="showRoomsList && roomsListOpenedCasted"
          :text-formatting="textFormattingCasted"
          :link-options="linkOptionsCasted"
          :is-mobile="isMobile"
          :loading-rooms="loadingRoomsCasted"
          :room-info-enabled="roomInfoEnabledCasted"
          :textarea-action-enabled="textareaActionEnabledCasted"
          :textarea-auto-focus="textareaAutoFocusCasted"
          :user-tags-enabled="userTagsEnabledCasted"
          :emojis-suggestion-enabled="emojisSuggestionEnabledCasted"
          :scroll-distance="scrollDistance"
          :accepted-files="acceptedFiles"
          :capture-files="captureFiles"
          :multiple-files="multipleFilesCasted"
          :templates-text="templatesTextCasted"
          :username-options="usernameOptionsCasted"
          :emoji-data-source="emojiDataSource"
          @toggle-rooms-list="toggleRoomsList"
          @room-info="roomInfo"
          @refresh-media="handleRefreshMedia"
          @fetch-messages="fetchMessages"
          @send-message="sendMessage"
          @send-voice="sendVoice"
          @edit-message="editMessage"
          @delete-message="deleteMessage"
          @open-file="openFile"
          @open-user-tag="openUserTag"
          @open-failed-message="openFailedMessage"
          @menu-action-handler="menuActionHandler"
          @message-action-handler="messageActionHandler"
          @message-selection-action-handler="messageSelectionActionHandler"
          @send-message-reaction="sendMessageReaction"
          @typing-message="typingMessage"
          @textarea-action-handler="textareaActionHandler"
          @show-right-info="handleClickShowRight"
          @close-room="closeRoom"
          @room-action-handler="roomActionHandler"
      >
        <template v-for="el in slots" #[el.slot]="data">
          <slot :name="el.slot" v-bind="data"/>
        </template>
      </room>
      <transition name="drawer-slide">
        <Drawer
            v-if="shouldShowDrawer"
            :mode="drawerMode"
            :current-user-id="currentUserId"
            :room="room"
            :messages="roomMessages"
            :messages-loaded="messagesLoadedCasted"
            :media-list="roomMediaList"
            :customer="roomCustomer"
            @closeDraw="closeDrawer"
            @preview-media="handleDrawerPreview"
            @archive="handleDrawerArchive"
            @archive-success="handleDrawerArchiveSuccess"
            @change-mode="handleDrawerChangeMode"
            @load-more-history="handleDrawerLoadMoreHistory"
            @locate-message="handleDrawerLocateMessage"
            @room-action-handler="roomActionHandler"
        />
      </transition>
    </div>
    <transition name="vac-fade-preview" appear>
      <media-preview
          v-if="showMediaPreview"
          :file="previewFile"
          @close-media-preview="showMediaPreview = false"
      >
        <template v-for="el in slots" #[el.slot]="data">
          <slot :name="el.slot" v-bind="data"/>
        </template>
      </media-preview>
    </transition>
    <!--    Create single chat-->
    <CreateChat ref="creatChat" @create="(val)=>$emit('add-room',val)"/>
    <!--    Exit login-->
    <ExitLoginConfirm ref="exitLogin" @confirm="handleLogoutConfirm"/>
    <!--    Message forward-->
    <ForwardMessage
        ref="messageForward"
        @send="handleForwardSend"
        @close="handleForwardClose"
    />
  </div>
</template>

<script>
import RoomsList from './RoomsList/RoomsList.vue'
import Room from './Room/Room.vue'
import MediaPreview from './MediaPreview/MediaPreview.vue'

import locales from '@/modules/whatsapp/locales'
import {defaultThemeStyles, cssThemeVars} from '@/modules/whatsapp/themes'
import {
  roomsValidation,
  partcipantsValidation
} from '@/modules/whatsapp/utils/data-validation'
import Drawer from "@/modules/whatsapp/components/Drawer/index.vue";
import CreateChat from "@/views/WhatsApp/Compontents/CreateChat.vue";
import ExitLoginConfirm from "@/views/WhatsApp/Compontents/ExitLoginConfirm.vue";
import DeleteChatConfirm from "@/views/WhatsApp/Compontents/DeleteChatConfirm.vue";
import ForwardMessage from "@/views/WhatsApp/Compontents/ForwardMessage.vue";
import {Storage} from "@/utils/storage";
import defaultUserAvatar from '@/modules/whatsapp/img/default_user_avatar.svg'
import { downloadFile } from '@/utils/file'
import { isImageFile } from '@/modules/whatsapp/utils/media-file'
import { getUserInfoBySession, logout as waLogout, updateUserContactInfo } from '@/api/whatsapp'
import {
  getExtensionFromMimetype,
  getExtensionFromNameOrUrl,
  isValidExtension,
  getSmartExtension,
  ensureFileExtension
} from '@/modules/whatsapp/utils/file-extension'

export default {
  name: 'ChatContainer',
  components: {
    Drawer,
    RoomsList,
    Room,
    MediaPreview,
    CreateChat,
    ExitLoginConfirm,
    DeleteChatConfirm,
    ForwardMessage
  },

  props: {
    height: {type: String, default: '600px'},
    theme: {type: String, default: 'light'},
    styles: {type: [Object, String], default: () => ({})},
    responsiveBreakpoint: {type: Number, default: 900},
    singleRoom: {type: [Boolean, String], default: false},
    roomsListOpened: {type: [Boolean, String], default: true},
    textMessages: {type: [Object, String], default: () => ({})},
    currentUserId: {type: String, default: ''},
    rooms: {type: [Array, String], default: () => []},
    roomsOrder: {type: String, default: 'desc'},
    loadingRooms: {type: [Boolean, String], default: false},
    roomsLoaded: {type: [Boolean, String], default: false},
    roomId: {type: String, default: null},
    loadFirstRoom: {type: [Boolean, String], default: true},
    messages: {type: [Array, String], default: () => []},
    messagesLoaded: {type: [Boolean, String], default: false},
    customer: {type: Object, default: null},
    roomActions: {type: [Array, String], default: () => []},
    menuActions: {type: [Array, String], default: () => []},
    messageActions: {
      type: [Array, String],
      default: () => []
    },
    messageSelectionActions: {type: [Array, String], default: () => []},
    autoScroll: {
      type: [Object, String],
      default: () => {
        return {
          send: {
            new: true,
            newAfterScrollUp: true
          },
          receive: {
            new: true,
            newAfterScrollUp: false
          }
        }
      }
    },
    scrollIcon: false, // 滚动提示图标显隐
    scrollMessagesCount: 0, // 未滚动的新消息数
    autoScrollOffset: 0,// 自动滚动偏移量（可选）
    customSearchRoomEnabled: {type: [Boolean, String], default: false},
    showSearch: {type: [Boolean, String], default: true},
    showAddRoom: {type: [Boolean, String], default: true},
    showSendIcon: {type: [Boolean, String], default: true},
    showFiles: {type: [Boolean, String], default: true},
    showAudio: {type: [Boolean, String], default: true},
    audioBitRate: {type: Number, default: 128},
    audioSampleRate: {type: Number, default: new (window.AudioContext || window.webkitAudioContext)().sampleRate},
    showEmojis: {type: [Boolean, String], default: true},
    showReactionEmojis: {type: [Boolean, String], default: true},
    showNewMessagesDivider: {type: [Boolean, String], default: true},
    showFooter: {type: [Boolean, String], default: true},
    textFormatting: {
      type: [Object, String],
      default: () => ({
        disabled: false
      })
    },
    linkOptions: {
      type: [Object, String],
      default: () => ({disabled: false, target: '_blank', rel: null})
    },
    roomInfoEnabled: {type: [Boolean, String], default: false},
    textareaActionEnabled: {type: [Boolean, String], default: false},
    textareaAutoFocus: {type: [Boolean, String], default: true},
    userTagsEnabled: {type: [Boolean, String], default: true},
    emojisSuggestionEnabled: {type: [Boolean, String], default: true},
    roomMessage: {type: String, default: ''},
    scrollDistance: {type: Number, default: 60},
    acceptedFiles: {type: String, default: '*'},
    captureFiles: {type: String, default: ''},
    multipleFiles: {type: [Boolean, String], default: true},
    templatesText: {type: [Array, String], default: () => []},
    mediaPreviewEnabled: {type: [Boolean, String], default: true},
    usernameOptions: {
      type: [Object, String],
      default: () => ({minUsers: 3, currentUser: false})
    },
    emojiDataSource: {type: String, default: undefined}
  },

  emits: [
    'toggle-rooms-list',
    'room-info',
    'refresh',
    'refresh-media',
    'fetch-messages',
    'send-message',
    'send-voice',
    'edit-message',
    'delete-message',
    'open-file',
    'open-user-tag',
    'open-failed-message',
    'menu-action-handler',
    'message-action-handler',
    'forward-message',
    'send-message-reaction',
    'typing-message',
    'textarea-action-handler',
    'fetch-more-rooms',
    'add-room',
    'search-room',
    'room-action-handler',
    'message-selection-action-handler',
    'close-room',
    'archive-success'
    ,
    'sync-finished',
    'room-menu-open'
  ],

  data() {
    return {
      slots: [],
      room: {},
      _downloadingKeys: new Set(),
      _downloadingNotices: new Map(),
      isDrawerShow: false,
      drawerMode: 'contact',
      showRoomsList: true,
      isMobile: false,
      showMediaPreview: false,
      previewFile: null,
      loadingMoreRooms: false,
      avatarLoadError: false,
      _lastFetchRoomId: '',
      _lastFetchAt: 0,
      loggingOut: false,
      syncingUserContact: false,
      _syncAlertTimer: null
    }
  },

  computed: {
    t() {
      return {
        ...locales,
        ...this.textMessagesCasted
      }
    },
    waUserInfo() {
      try {
        // 获取当前系统用户ID
        const userInfo = Storage.get('userInfo')
        const systemUserId = userInfo?.id || userInfo?.userId
        const userId = systemUserId ? String(systemUserId) : ''
        
        // 优先读取账号特定的缓存
        if (userId) {
          const cached = Storage.get(`wa_login_user_${userId}`)
          if (cached) {
            return cached
          }
        }
        
        // 如果没有账号特定缓存，再读取通用缓存（兼容旧数据）
        return Storage.get('wa_login_user') || {}
      } catch (e) {
        return {}
      }
    },
    waUserDisplayName() {
      return this.waUserInfo?.name || this.waUserInfo?.pushName || this.waUserInfo?.id || ''
    },
    waUserDisplayId() {
      const raw = this.waUserInfo?.id || this.currentUserId || ''
      return String(raw || '').replace(/@c\.us$/i, '')
    },
    avatarSrc() {
      if (this.avatarLoadError) return defaultUserAvatar
      const raw = this.waUserInfo?.picture
      const url = this.normalizeAvatarUrl(raw)
      return url ? url : defaultUserAvatar
    },
    avatarIsDefault() {
      return this.avatarSrc === defaultUserAvatar
    },
    avatarBgStyle() {
      const size = this.avatarIsDefault ? '50% 50%' : 'cover'
      return {
        backgroundImage: `url("${this.avatarSrc}")`,
        backgroundSize: size
      }
    },
    cssVars() {
      const defaultStyles = defaultThemeStyles[this.theme]
      const customStyles = {}

      Object.keys(defaultStyles).map(key => {
        customStyles[key] = {
          ...defaultStyles[key],
          ...(this.stylesCasted[key] || {})
        }
      })

      return cssThemeVars(customStyles)
    },
    orderedRooms() {
      return this.roomsCasted.slice().sort((a, b) => {
        const aPinned = !!a?.isPinned
        const bPinned = !!b?.isPinned
        if (aPinned !== bPinned) return aPinned ? -1 : 1

        const aVal = a.index || 0
        const bVal = b.index || 0

        if (this.roomsOrder === 'asc') {
          return aVal < bVal ? -1 : bVal < aVal ? 1 : 0
        }

        return aVal > bVal ? -1 : bVal > aVal ? 1 : 0
      })
    },
    hasSelectedRoom() {
      const rid = this.room?.roomId || this.roomId
      if (this.room?.isTemp) return false
      return !!(rid && String(rid).trim())
    },
    isGroupRoom() {
      if (!this.room) return false
      if (this.room?.isGroup === true) return true
      if (this.room?.type === 'group') return true
      const rid = this.room?.roomId
      return typeof rid === 'string' ? rid.includes('@g.us') : false
    },
    isMyCustomer() {
      return this.room?.contactInfo?.isMyCustomer === true
    },
    shouldShowDrawer() {
      if (!this.isDrawerShow) return false
      if (!this.hasSelectedRoom) return false
      // 群组对话不可归档：进入 archive 模式时直接关闭抽屉
      if (this.drawerMode === 'archive' && this.isGroupRoom) return false
      if (this.drawerMode === 'archive' && this.isMyCustomer) return false
      return true
    },
    singleRoomCasted() {
      return this.castBoolean(this.singleRoom)
    },
    roomsListOpenedCasted() {
      return this.castBoolean(this.roomsListOpened)
    },
    loadingRoomsCasted() {
      return this.castBoolean(this.loadingRooms)
    },
    roomsLoadedCasted() {
      return this.castBoolean(this.roomsLoaded)
    },
    loadFirstRoomCasted() {
      return this.castBoolean(this.loadFirstRoom)
    },
    messagesLoadedCasted() {
      return this.castBoolean(this.messagesLoaded)
    },
    multipleFilesCasted() {
      return this.castBoolean(this.multipleFiles)
    },
    showSearchCasted() {
      return this.castBoolean(this.showSearch)
    },
    showAddRoomCasted() {
      return this.castBoolean(this.showAddRoom)
    },
    showSendIconCasted() {
      return this.castBoolean(this.showSendIcon)
    },
    showFilesCasted() {
      return this.castBoolean(this.showFiles)
    },
    showAudioCasted() {
      return this.castBoolean(this.showAudio)
    },
    showEmojisCasted() {
      return this.castBoolean(this.showEmojis)
    },
    showReactionEmojisCasted() {
      return this.castBoolean(this.showReactionEmojis)
    },
    showNewMessagesDividerCasted() {
      return this.castBoolean(this.showNewMessagesDivider)
    },
    showFooterCasted() {
      return this.castBoolean(this.showFooter)
    },
    roomInfoEnabledCasted() {
      return this.castBoolean(this.roomInfoEnabled)
    },
    textareaActionEnabledCasted() {
      return this.castBoolean(this.textareaActionEnabled)
    },
    textareaAutoFocusCasted() {
      return this.castBoolean(this.textareaAutoFocus)
    },
    userTagsEnabledCasted() {
      return this.castBoolean(this.userTagsEnabled)
    },
    emojisSuggestionEnabledCasted() {
      return this.castBoolean(this.emojisSuggestionEnabled)
    },
    mediaPreviewEnabledCasted() {
      return this.castBoolean(this.mediaPreviewEnabled)
    },
    roomsCasted() {
      return this.castArray(this.rooms)
    },
    roomsWithSelected() {
      const base = this.roomsCasted
      const selected = this.room
      const rid = selected?.roomId
      if (!rid || !String(rid).trim()) return base
      const exists = base.find((r) => r && String(r.roomId || '') === String(rid))
      if (exists) return base
      return [...base, selected]
    },
    messagesCasted() {
      return this.castArray(this.messages)
    },
    roomActionsCasted() {
      return this.castArray(this.roomActions)
    },
    menuActionsCasted() {
      return this.castArray(this.menuActions)
    },
    messageActionsCasted() {
      return this.castArray(this.messageActions)
    },
    messageSelectionActionsCasted() {
      return this.castArray(this.messageSelectionActions)
    },
    templatesTextCasted() {
      return this.castArray(this.templatesText)
    },
    stylesCasted() {
      return this.castObject(this.styles)
    },
    textMessagesCasted() {
      return this.castObject(this.textMessages)
    },
    autoScrollCasted() {
      return this.castObject(this.autoScroll)
    },
    textFormattingCasted() {
      return this.castObject(this.textFormatting)
    },
    linkOptionsCasted() {
      return this.castObject(this.linkOptions)
    },
    usernameOptionsCasted() {
      return this.castObject(this.usernameOptions)
    },
    roomMessages() {
      const msgs = this.messagesCasted
      const rid = this.room?.roomId
      if (!rid) return msgs
      return msgs.filter((m) => !m.roomId || m.roomId === rid)
    },
    roomMediaList() {
      const list = []
      this.roomMessages.forEach((m) => {
        const msgTs = Number(m?.timestamp || m?.ts || m?.time || m?.createTime || m?.updateTime || 0)
        const files = m.files || []
        files.forEach((f) => {
          if (f.url || f.preview) {
            list.push({
              ...f,
              type: f.type || 'image/png',
              url: f.url || f.preview,
              preview: f.preview || f.url,
              timestamp: Number(f?.timestamp || f?.ts || f?.time || msgTs || 0)
            })
          }
        })
        const reply = m.replyMessage
        if (reply?.files) {
          reply.files.forEach((f) => {
            if (f.url || f.preview) {
              list.push({
                ...f,
                type: f.type || 'image/png',
                url: f.url || f.preview,
                preview: f.preview || f.url,
                timestamp: Number(f?.timestamp || f?.ts || f?.time || msgTs || 0)
              })
            }
          })
        }
      })
      list.sort((a, b) => Number(b?.timestamp || 0) - Number(a?.timestamp || 0))
      return list
    },
    roomCustomer() {
      return this.room?.customer || this.customer || null
    }
  },

  watch: {
    drawerMode(val) {
      if (val === 'archive' && this.isGroupRoom) {
        this.isDrawerShow = false
      }
      if (val === 'archive' && this.isMyCustomer) {
        this.isDrawerShow = false
      }
    },
    roomsCasted: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (
            !newVal[0] ||
            !newVal.find(room => room.roomId === this.room?.roomId)
        ) {
          this.showRoomsList = true
        }

        // 🔥 修复：只有在 loadFirstRoom 为 true 时才自动选择第一个对话
        // 避免进入 /whatsapp 页面时自动选择第一个对话并清空其未读消息
        if (
            !this.loadingMoreRooms &&
            this.loadFirstRoomCasted &&
            newVal[0] &&
            (!oldVal || newVal.length !== oldVal.length)
        ) {
          if (this.roomId) {
            const room = newVal.find(r => r.roomId === this.roomId)
            // When selecting a room from label tabs, the room may not exist in `rooms`.
            // Do not override the currently selected room with an empty object.
            if (room) this.fetchRoom({room})
          } else if (!this.isMobile || this.singleRoomCasted) {
            // 🔥 注意：这里会自动选择第一个对话
            // 由于 Home 组件设置了 :load-first-room="false"，这段代码不应该执行
            console.log('[ChatWindow] Auto-selecting first room (loadFirstRoom:', this.loadFirstRoom, 'casted:', this.loadFirstRoomCasted, ')')
            this.fetchRoom({room: this.orderedRooms[0]})
          } else {
            this.showRoomsList = true
          }
        }
      }
    },

    loadingRoomsCasted(val) {
      if (val) this.room = {}
    },

    roomId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && !this.loadingRoomsCasted && this.roomsCasted.length) {
          // Guard: room click already triggers fetchRoom -> fetchMessages.
          // Parent then updates `roomId` prop, which would otherwise trigger a second fetch.
          try {
            const nextId = String(newVal)
            const lastId = String(this._lastFetchRoomId || '')
            const lastAt = Number(this._lastFetchAt || 0)
            if (nextId && lastId && nextId === lastId && Date.now() - lastAt < 1500) {
              return
            }
          } catch (e) {
          }
          // If the room is selected from label tabs, it may not be present in `rooms`.
          // In that case keep the current room instead of overriding it.
          if (this.room?.roomId && String(this.room.roomId) === String(newVal)) {
            return
          }
          const room = this.roomsCasted.find(r => r.roomId === newVal)
          if (room) this.fetchRoom({room})
        } else if (oldVal && !newVal) {
          this.room = {}
        }
      }
    },

    room(val) {
      if (!val || Object.entries(val).length === 0) return

      // During async room switching (e.g. tabs / labels), a transient invalid room object
      // may be set. Do not let validation throw and crash the render pipeline.
      try {
        // Fast pre-check to avoid throwing on obviously invalid shapes
        if (!('roomId' in val) || !('roomName' in val) || !('users' in val)) {
          this.room = {}
          return
        }

        roomsValidation(val)

        ;(Array.isArray(val.users) ? val.users : []).forEach(user => {
          partcipantsValidation(user)
        })
      } catch (e) {
        this.room = {}
      }

      if (this.drawerMode === 'archive' && this.isGroupRoom) {
        this.isDrawerShow = false
      }
    },

    roomsListOpenedCasted: {
      immediate: true,
      handler(val) {
        this.showRoomsList = val
      }
    }
  },

  created() {
    this.updateResponsive()
    window.addEventListener('resize', ev => {
      if (ev.isTrusted) this.updateResponsive()
    })
  },

  updated() {
    const slots = document.querySelectorAll('[slot]')
    if (this.slots.length !== slots.length) {
      this.slots = slots
    }
  },

  methods: {
    handleRefreshMedia(payload) {
      this.$emit('refresh-media', payload)
    },
    handleRoomMenuOpen(payload) {
      this.$emit('room-menu-open', payload)
    },
    clearWhatsAppCache() {
      try {
        // 获取当前系统用户ID
        const userInfo = Storage.get('userInfo')
        const systemUserId = userInfo?.id || userInfo?.userId
        const userId = systemUserId ? String(systemUserId) : ''
        
        // 清除通用 key 和账号特定 key
        Storage.remove('wa_login_user')
        if (userId) {
          Storage.remove(`wa_login_user_${userId}`)
          console.log(`[ChatWindow] 清除 WhatsApp 缓存: systemUserId=${userId}`)
        }
      } catch (e) {
        console.error('[ChatWindow] 清除 wa_login_user 失败:', e)
      }
      try {
        Storage.remove('wa_jid_map')
      } catch (e) {
      }
      try {
        window.__waActiveRoomId = ''
      } catch (e) {
      }
    },
    ensureRoomContext(roomId) {
      const rid = String(roomId || '').trim()
      if (!rid) return

      if (this.room?.roomId && String(this.room.roomId) === rid) return

      const existing = (this.roomsCasted || []).find((r) => r && String(r.roomId) === rid) || null
      if (existing) {
        this.fetchRoom({ room: existing })
        return
      }

      // Fallback: keep a minimal, valid room shape so Drawer can render.
      // Real room data will overwrite once rooms/messages are fetched by parent.
      this.room = {
        roomId: rid,
        roomName: rid,
        users: [
          { _id: this.currentUserId, username: '我' },
          { _id: rid, username: rid }
        ]
      }
      try {
        this.fetchMessages({ reset: true })
      } catch (e) {
      }
    },
    ensureRoomContext(roomId) {
      const rid = String(roomId || '').trim()
      if (!rid) return

      if (this.room?.roomId && String(this.room.roomId) === rid) return

      const existing = (this.roomsCasted || []).find((r) => r && String(r.roomId) === rid) || null
      if (existing) {
        this.fetchRoom({ room: existing })
        return
      }

      // Fallback: keep a minimal, valid room shape so Drawer can render.
      // Real room data will overwrite once rooms/messages are fetched by parent.
      this.room = {
        roomId: rid,
        roomName: rid,
        users: [
          { _id: this.currentUserId, username: '我' },
          { _id: rid, username: rid }
        ]
      }
      try {
        this.fetchMessages({ reset: true })
      } catch (e) {
      }
    },
    normalizeDownloadUrl(url) {
      const u = String(url || '').trim()
      if (!u) return ''
      return u
    },
    getDownloadCandidateUrls(rawUrl) {
      const u = this.normalizeDownloadUrl(rawUrl)
      if (!u) return []

      if (/^https?:\/\//i.test(u)) {
        return [u]
      }

      if (u.startsWith('//')) {
        const httpsUrl = `https:${u}`
        const originProto = `${window.location.protocol}${u}`
        return Array.from(new Set([originProto, httpsUrl]))
      }

      if (u.startsWith('/')) {
        return [`${window.location.origin}${u}`]
      }

      return [u]
    },
    downloadWithProgress(url, onProgress) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        
        // 监听下载进度
        xhr.onprogress = (event) => {
          if (event.lengthComputable) {
            onProgress(event.loaded, event.total)
          } else {
            // 如果服务器没有返回 Content-Length，只显示已下载大小
            onProgress(event.loaded, 0)
          }
        }
        
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          } else {
            reject(new Error(`HTTP status: ${xhr.status}`))
          }
        }
        
        xhr.onerror = () => {
          reject(new Error('网络错误'))
        }
        
        xhr.ontimeout = () => {
          reject(new Error('下载超时'))
        }
        
        xhr.send()
      })
    },
    getDownloadFileName({ message, file }) {
      const f = file?.file || file || {}
      const m = message || {}

      // 获取 mimetype（从 message.media 或 file 对象）
      const mimetype = m?.media?.mimetype || m?.__mediaMimetype || f?.type || ''

      // 1. Prefer media.filename from the message
      let mediaFilename = String(m?.media?.filename || '').trim()
      if (mediaFilename) {
        const correctedFilename = ensureFileExtension(mediaFilename, mimetype)
        console.log('[下载] 使用 message.media.filename:', correctedFilename)
        return correctedFilename
      }

      // 2. Use fileName from file object (complete filename stored in cache)
      let fileName = String(f?.fileName || '').trim()
      if (fileName) {
        const correctedFilename = ensureFileExtension(fileName, mimetype)
        console.log('[下载] 使用 file.fileName:', correctedFilename)
        return correctedFilename
      }

      // 3. Fallback to name field (may be without extension)
      const name = String(f?.name || '').trim()
      const url = String(f?.url || f?.localUrl || '').trim()
      
      if (name) {
        const ext = getSmartExtension({ url, mimetype, filename: name })
        const hasExt = name.includes('.') && name.split('.').pop()
        
        if (hasExt && isValidExtension(name.split('.').pop())) {
          console.log('[下载] 使用 file.name (带扩展名):', name)
          return name
        }
        if (ext) {
          const fullName = `${name}.${ext}`
          console.log('[下载] 使用 file.name + 扩展名:', fullName)
          return fullName
        }
        console.log('[下载] 使用 file.name:', name)
        return name
      }

      // 4. Generate fallback filename
      const ts = Date.now()
      const base = m?._id ? `attachment_${m._id}` : `attachment_${ts}`
      const ext = getSmartExtension({ url, mimetype })
      const fallbackName = ext ? `${base}.${ext}` : base
      console.log('[下载] 使用生成的文件名:', fallbackName)
      return fallbackName
    },
    getDownloadKey({ message, file, rawUrl, filename }) {
      const m = message || {}
      const f = file?.file || file || {}
      const url0 = String(rawUrl || f?.url || f?.localUrl || '').trim()
      const name0 = String(filename || f?.name || f?.fileName || '').trim()
      // Include roomId/messageId to avoid collisions when same filename/url appears in different rooms.
      const rid = String(m?.roomId || this.room?.roomId || '')
      const mid = String(m?._id || '')
      return [rid, mid, name0, url0].join('::')
    },
    notifyDownloading(key, filename) {
      try {
        if (!key) return
        const now = Date.now()
        const lastAt = Number(this._downloadingNotices?.get(key) || 0)
        // throttle repeated clicks to avoid spamming toasts
        if (lastAt && now - lastAt < 1200) return
        this._downloadingNotices.set(key, now)

        const rawName = String(filename || '').trim()
        const clampName = (s, max = 24) => {
          const str = String(s || '')
          if (!str) return ''
          if (str.length <= max) return str
          const head = Math.max(10, Math.floor((max - 1) * 0.6))
          const tail = Math.max(6, max - 1 - head)
          return `${str.slice(0, head)}…${str.slice(-tail)}`
        }
        const shownName = clampName(rawName)
        const text = shownName ? `正在下载：${shownName}` : '正在下载…'
        this.$message?.info?.({
          message: text,
          duration: 2500
        })
      } catch (e) {
      }
    },
    closeDownloadingNotice(key) {
      try {
        if (!key) return
        this._downloadingNotices?.delete(key)
      } catch (e) {
      }
    },
    normalizeAvatarUrl(raw) {
      const s = typeof raw === 'string' ? raw.trim() : ''
      if (!s) return ''

      // absolute url
      if (/^https?:\/\//i.test(s)) return s

      // protocol relative
      if (s.startsWith('//')) return `${window.location.protocol}${s}`

      // relative path -> resolve against current origin
      if (s.startsWith('/')) return `${window.location.origin}${s}`

      return s
    },
    handleAvatarError(e) {
      this.avatarLoadError = true
      const img = e?.target
      if (img && img.src !== defaultUserAvatar) img.src = defaultUserAvatar
    },
    handleAvatarLoad() {
      this.avatarLoadError = false
    },
    // Create single chat
    handleClickCreate() {
      this.$refs.creatChat.open()
    },
    // Page refresh
    async handleRefresh() {
      if (this.syncingUserContact) return

      // Refresh rooms will often reset selected room in parent.
      // Close drawer immediately to avoid showing stale drawer content.
      this.isDrawerShow = false
      this.drawerMode = 'contact'
      this.isDrawerShow = false
      this.room = {}
      this.showRoomsList = true

      this.$emit('refresh')

      this.syncingUserContact = true
      try {
        if (typeof updateUserContactInfo === 'function') {
          await updateUserContactInfo({}, { errorPop: false })
        }
        try {
          this.$message?.success?.('同步成功')
        } catch (e) {
        }
      } catch (e) {
        try {
          this.$message?.error?.('同步失败，请稍后再试')
        } catch (e2) {
        }
      } finally {
        this.syncingUserContact = false
      }

      this.$emit('sync-finished')
    },
    // User logout
    handleLogout() {
      this.$refs.exitLogin.open()
    },
    async handleLogoutConfirm() {
      if (this.loggingOut) return
      this.loggingOut = true

      try {
        if (typeof waLogout !== 'function') return

        await waLogout({}, { errorPop: false })

        const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

        let logoutOk = false
        for (let i = 0; i < 3; i++) {
          let checkRes = null
          try {
            checkRes = await getUserInfoBySession({}, { errorPop: false })
          } catch (e) {
            checkRes = null
          }

          const msg = String(checkRes?.message || '')
          if (checkRes && checkRes.code === 200) {
            logoutOk = false
          } else if (msg.includes('未登录')) {
            logoutOk = true
            break
          }

          await wait(500)
        }

        if (!logoutOk) {
          this.$message?.error?.('退出失败')
          return
        }

        try {
          Storage.set('wa_manual_logout', Date.now())
        } catch (e) {
        }

        try {
          const d = new Date()
          const y = d.getFullYear()
          const m = String(d.getMonth() + 1).padStart(2, '0')
          const day = String(d.getDate()).padStart(2, '0')
          Storage.remove(`wa_rooms_ban_alert_closed_${y}${m}${day}`)
        } catch (e) {
        }

        try {
          this.clearWhatsAppCache()
        } catch (e) {
        }
        try {
          this.room = {}
          this.isDrawerShow = false
          this.showRoomsList = true
          this.$emit('close-room')
        } catch (e) {
        }

        try {
          this.$router?.replace?.('/whatsapp/walogin')
        } catch (e) {
        }
      } catch (e) {
        this.$message?.error?.('退出失败')
      } finally {
        this.loggingOut = false
      }
    },
    handleClickRight() {
      this.drawerMode = 'search'
      this.isDrawerShow = true
    },
    closeDrawer() {
      this.isDrawerShow = false
    },
    handleClickShowRight(mode) {
      const allow = ['contact', 'search', 'customer', 'media', 'archive']
      const nextMode = allow.includes(mode) ? mode : 'search'
      if (nextMode === 'archive' && this.isMyCustomer) {
        return
      }
      this.drawerMode = nextMode
      this.isDrawerShow = true
    },
    handleDrawerArchive() {
      if (this.isMyCustomer) {
        return
      }
      this.$emit('room-action-handler', {action: {name: 'archive'}, roomId: this.room?.roomId})
    },
    handleDrawerArchiveSuccess(payload) {
      this.$emit('archive-success', payload)
    },
    handleDrawerPreview(file) {
      if (!file || !file.url) return
      if (!this.mediaPreviewEnabledCasted) return

      this.previewFile = file
      this.showMediaPreview = true
    },
    handleDrawerChangeMode(mode) {
      const allow = ['contact', 'search', 'customer', 'media', 'archive']
      if (!allow.includes(mode)) return
      this.drawerMode = mode
      this.isDrawerShow = true
    },
    handleDrawerLoadMoreHistory() {
      // 复用现有消息分页逻辑：继续拉取更老的一页
      this.fetchMessages({})
    },
    handleDrawerLocateMessage(item) {
      const messageId = item?.messageId || item?._id || item?.id
      if (!messageId) return

      const tryLocate = () => {
        return this.$refs.roomRef?.locateMessageById?.(messageId) === true
      }

      // 1) 先尝试在当前已加载列表里定位
      this.$nextTick(() => {
        if (tryLocate()) return

        // 2) 未命中：逐页加载更老历史并重试（最多 8 次，避免死循环）
        let attempts = 0
        const maxAttempts = 8
        const loop = () => {
          if (attempts >= maxAttempts) {
            this.$message?.warning?.('未定位到该条历史记录，可能需要继续下拉加载更多消息')
            return
          }
          if (this.messagesLoadedCasted) {
            this.$message?.warning?.('已加载到最早消息，仍未找到该条历史记录')
            return
          }
          attempts += 1

          const beforeLen = Array.isArray(this.messagesCasted) ? this.messagesCasted.length : 0
          const p = this.fetchMessages({})

          Promise.resolve(p)
            .finally(() => {
              this.$nextTick(() => {
                if (tryLocate()) return

                const afterLen = Array.isArray(this.messagesCasted) ? this.messagesCasted.length : 0
                // 长度没变化：防止接口异常导致无限重试
                if (afterLen <= beforeLen) {
                  this.$message?.warning?.('历史消息加载失败或无更多数据，无法定位该条记录')
                  return
                }
                loop()
              })
            })
        }
        loop()
      })
    },
    //
    castBoolean(val) {
      return val === 'true' || val === true
    },
    castArray(val) {
      return !val ? [] : Array.isArray(val) ? val : JSON.parse(val)
    },
    castObject(val) {
      return !val ? {} : typeof val === 'object' ? val : JSON.parse(val)
    },
    updateResponsive() {
      this.isMobile = window.innerWidth < Number(this.responsiveBreakpoint)
    },
    toggleRoomsList() {
      this.showRoomsList = !this.showRoomsList
      if (this.isMobile) this.room = {}
      this.$emit('toggle-rooms-list', {opened: this.showRoomsList})
    },
    closeRoom() {
      // 关闭当前对话，清空房间并显示房间列表
      this.room = {}
      this.isDrawerShow = false
      this.showRoomsList = true
      this.$emit('close-room')
    },
    fetchRoom({room}) {
      // 防御：roomId watcher 可能会在 rooms 列表尚未包含该 room 时传入空对象（{}）。
      // 如果这里直接 return，会导致 roomId 已经有值但 Drawer 的 v-if(hasSelectedRoom) 不成立，从而“选中 room 不自动打开抽屉”。
      if (!room || !room.roomId) {
        const rid = this.roomId
        if (rid && String(rid).trim()) {
          // 使用占位 room，保证 hasSelectedRoom=true，让 Drawer 先渲染出来；
          // 等 rooms 加载后再用真实 room 覆盖。
          this.room = {
            roomId: rid,
            roomName: String(rid),
            users: [
              { _id: this.currentUserId, username: '我' },
              { _id: String(rid), username: String(rid) }
            ]
          }
          this.isDrawerShow = !!(this.isDrawerShow)
          if (this.isMobile) this.showRoomsList = false
        }
        return
      }

      const nextRoomId = String(room.roomId)
      const now = Date.now()
      // Same room selected in a very short time window -> ignore duplicated fetch.
      // This typically happens because both user click and roomId watcher call fetchRoom.
      if (this._lastFetchRoomId === nextRoomId && now - (this._lastFetchAt || 0) < 300) {
        this.room = room
        this.isDrawerShow = !!(this.isDrawerShow && !room.isTemp)
        if (this.isMobile) this.showRoomsList = false
        return
      }
      this._lastFetchRoomId = String(room?.roomId || '')
      this._lastFetchAt = Date.now()
      this.room = room
      // 选中任何一个 room 时，Drawer 需要打开
      this.isDrawerShow = !!(this.isDrawerShow && !room.isTemp)
      this.fetchMessages({reset: true})
      if (this.isMobile) this.showRoomsList = false
    },
    fetchMoreRooms() {
      this.$emit('fetch-more-rooms')
    },
    roomInfo() {
      this.drawerMode = 'search'
      this.isDrawerShow = true
      this.$emit('room-info', this.room)
    },
    addRoom() {
      this.$emit('add-room')
    },
    searchRoom(val) {
      this.$emit('search-room', {value: val, roomId: this.room?.roomId})
    },
    fetchMessages(options) {
      this.$emit('fetch-messages', {room: this.room, options})
    },
    sendMessage(message) {
      this.$emit('send-message', {...message, roomId: this.room?.roomId})
    },
    sendVoice(message) {
      this.$emit('send-voice', {...message, roomId: this.room?.roomId})
    },
    editMessage(message) {
      this.$emit('edit-message', {...message, roomId: this.room?.roomId})
    },
    deleteMessage(message) {
      this.$emit('delete-message', {message, roomId: this.room?.roomId})
    },
    async openFile({message, file}) {
      if (this.mediaPreviewEnabledCasted && file?.action === 'preview') {
        this.previewFile = file.file
        this.showMediaPreview = true
        return
      }

      if (file?.action === 'download') {
        const rawUrl = file?.file?.url || file?.file?.localUrl || ''
        const candidateUrls = this.getDownloadCandidateUrls(rawUrl)
        if (!candidateUrls.length) {
          this.$message?.warning?.('下载链接为空')
          return
        }

        console.log('[下载] message:', message)
        console.log('[下载] file:', file)
        const filename = this.getDownloadFileName({ message, file })
        console.log('[下载] 最终文件名:', filename)
        const downloadKey = this.getDownloadKey({ message, file, rawUrl: candidateUrls[0], filename })
        if (this._downloadingKeys?.has(downloadKey)) {
          this.notifyDownloading(downloadKey, filename)
          return
        }
        this._downloadingKeys.add(downloadKey)
        
        // 创建一个固定在右下角的进度提示框
        let progressElement = null
        const createProgressElement = () => {
          const el = document.createElement('div')
          el.className = 'download-progress-toast'
          el.style.cssText = `
            position: fixed;
            bottom: 20px;
            right: 20px;
            min-width: 320px;
            max-width: 400px;
            padding: 16px 20px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            z-index: 9999;
            font-size: 14px;
            line-height: 1.6;
            color: #333;
            transition: all 0.3s ease;
          `
          el.innerHTML = `
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <div style="width: 20px; height: 20px; border: 2px solid #409eff; border-top-color: transparent; border-radius: 50%; animation: spin 0.8s linear infinite; margin-right: 10px;"></div>
              <div style="font-weight: 500; color: #409eff;">正在下载</div>
            </div>
            <div class="progress-filename" style="margin-bottom: 8px; color: #606266; word-break: break-all;"></div>
            <div class="progress-bar" style="width: 100%; height: 6px; background: #e4e7ed; border-radius: 3px; overflow: hidden; margin-bottom: 6px;">
              <div class="progress-bar-inner" style="height: 100%; background: linear-gradient(to right, #409eff, #66b1ff); border-radius: 3px; width: 0%; transition: width 0.3s ease;"></div>
            </div>
            <div class="progress-text" style="font-size: 12px; color: #909399;"></div>
          `
          
          // 添加旋转动画
          const style = document.createElement('style')
          style.textContent = `
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `
          document.head.appendChild(style)
          
          document.body.appendChild(el)
          return el
        }
        
        const showProgress = (percent, loaded, total) => {
          if (!progressElement) {
            progressElement = createProgressElement()
          }
          
          const loadedMB = (loaded / 1024 / 1024).toFixed(2)
          const totalMB = total ? (total / 1024 / 1024).toFixed(2) : '未知'
          const percentText = percent >= 0 ? `${percent}%` : '计算中...'
          
          // 更新文件名
          const filenameEl = progressElement.querySelector('.progress-filename')
          if (filenameEl) {
            filenameEl.textContent = filename
          }
          
          // 更新进度条
          const progressBarInner = progressElement.querySelector('.progress-bar-inner')
          if (progressBarInner && percent >= 0) {
            progressBarInner.style.width = `${percent}%`
          }
          
          // 更新进度文本
          const progressTextEl = progressElement.querySelector('.progress-text')
          if (progressTextEl) {
            progressTextEl.textContent = `${percentText} (${loadedMB}MB${total ? ` / ${totalMB}MB` : ''})`
          }
        }
        
        const removeProgressElement = () => {
          if (progressElement && progressElement.parentNode) {
            progressElement.style.opacity = '0'
            progressElement.style.transform = 'translateY(20px)'
            setTimeout(() => {
              if (progressElement && progressElement.parentNode) {
                progressElement.parentNode.removeChild(progressElement)
              }
              progressElement = null
            }, 300)
          }
        }
        
        try {
          // 使用 XMLHttpRequest 来支持进度监听
          let lastError = null
          for (const url of candidateUrls) {
            try {
              const blob = await this.downloadWithProgress(url, (loaded, total) => {
                const percent = total > 0 ? Math.round((loaded / total) * 100) : -1
                showProgress(percent, loaded, total)
              })
              
              // 下载完成，移除进度提示
              removeProgressElement()
              
              // 触发浏览器下载
              downloadFile(blob, filename)
              
              // 显示成功提示
              const displayName = filename.length > 40 ? filename.substring(0, 37) + '...' : filename
              this.$message?.success?.(`下载完成: ${displayName}`)
              
              lastError = null
              break
            } catch (e) {
              lastError = e
            }
          }

          if (lastError) {
            // 如果 fetch 失败（可能是 CORS 问题），尝试在新标签页打开
            removeProgressElement()
            const fallbackUrl = candidateUrls[0]
            this.$message?.warning?.('无法获取下载进度，将在新标签页打开')
            window.open(fallbackUrl, '_blank', 'noopener')
          }
        } catch (e) {
          console.error('下载失败:', e)
          removeProgressElement()
          this.$message?.error?.('下载失败: ' + (e.message || '未知错误'))
        } finally {
          this.closeDownloadingNotice(downloadKey)
          try {
            this._downloadingKeys?.delete(downloadKey)
          } catch (e) {
          }
        }
        return
      }

      this.$emit('open-file', {message, file})
    },
    openUserTag({user}) {
      this.$emit('open-user-tag', {user})
    },
    openFailedMessage({message}) {
      this.$emit('open-failed-message', {
        message,
        roomId: this.room?.roomId
      })
    },
    menuActionHandler(ev) {
      this.$emit('menu-action-handler', {
        action: ev,
        roomId: this.room?.roomId
      })
    },
    roomActionHandler({action, roomId}) {
      if (action?.name === 'archive') {
        if (this.isMyCustomer) {
          return
        }
        this.ensureRoomContext(roomId)
        this.drawerMode = 'archive'
        this.isDrawerShow = true
      }
      this.$emit('room-action-handler', {action, roomId})
    },
    messageActionHandler(ev) {
      this.$emit('message-action-handler', {
        ...ev,
        roomId: this.room?.roomId
      })
    },
    messageSelectionActionHandler(ev) {
      if (ev.action.name === 'forwardSelected') {
        const msgs = Array.isArray(ev?.messages) ? ev.messages : []
        if (msgs.length) {
          this.$refs.messageForward.open({ messages: msgs })
        } else {
          const msg = ev?.messages?.[0] || null
          this.$refs.messageForward.open(msg)
        }
      } else {
        this.$emit('message-selection-action-handler', {
          ...ev,
          roomId: this.room?.roomId
        })
      }
    },
    handleForwardSend(payload) {
      this.$emit('forward-message', {
        ...payload,
        roomId: this.room?.roomId
      })
    },
    handleForwardClose() {
      this.$emit('forward-message', {
        roomId: this.room?.roomId,
        canceled: true
      })
    },
    sendMessageReaction(messageReaction) {
      this.$emit('send-message-reaction', {
        ...messageReaction,
        roomId: this.room?.roomId
      })
    },
    typingMessage(message) {
      this.$emit('typing-message', {
        message,
        roomId: this.room?.roomId
      })
    },
    textareaActionHandler(message) {
      this.$emit('textarea-action-handler', {
        message,
        roomId: this.room?.roomId
      })
    }
  }
}
</script>

<style lang="scss">
@use '@/modules/whatsapp/styles/index.scss' as *;

.userInfo {
  height: 64px;
  width: 100%;
  background: #F0F0F0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .wa-user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-position: center;
    background-repeat: no-repeat;
    flex: 0 0 40px;
   background-color:#ddd
  }

  .wa-user-avatar-preload {
    display: none;
  }

  .username {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #0D0E15;
  }

  .userid {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #B3B3B3;
    margin-top: 4px;
  }

  .right {
    img {
      width: 16px;
      height: 16px;
      margin: 0px 12px;
      cursor: pointer;
    }
  }
}

@keyframes wa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.wa-refresh-rotating {
  animation: wa-spin 0.9s linear infinite;
}

.settings {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.drawer-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 360px;
  background: #fff;
  z-index: 2000;
}

/* 进入前 */
.drawer-slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

/* 进入后 */
.drawer-slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}

/* 离开前 */
.drawer-slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

/* 离开后 */
.drawer-slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* 动画时间 */
.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: all 0.1s ease;
}

</style>
